module.exports = __webpack_public_path__ + "static/media/notification-error.c35186a6.svg";